<template>
    <div>
        <span class="timer">{{ state.timeLeft }}</span>
    </div>
</template>

<script lang="ts">
import { onMounted, reactive, watch } from "vue";

export default {
    props: {
        timer: {
            type: Number,
        },
    },
    emits: ["end"],
    setup(props: any, { emit }: any) {
        const state = reactive({
            authCode: "" as string,
            timeLeft: "" as string,
        });

        interface Timer {
            seconds: number;
            countdown: number | null;
        }
        const timer = reactive<Timer>({
            seconds: props.timer,
            countdown: null,
        });

        const formatTime = (seconds: number): string => {
            const minutes = Math.floor(seconds / 60);
            const remainingSeconds = seconds % 60;
            return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
        };

        watch(props, () => {
            timer.seconds = props.timer;
            startTimer();
        });
        const startTimer = (): void => {
            state.timeLeft = formatTime(timer.seconds); // 타이머 시작 시 즉시 초기화
            timer.countdown = setInterval(() => {
                timer.seconds--;
                state.timeLeft = formatTime(timer.seconds); // 초마다 업데이트
                if (timer.seconds <= 0) {
                    clearInterval(timer.countdown!);
                    timeOut();
                }
            }, 1000);
        };

        const timeOut = () => {
            emit("end");
        };
        return {
            state,
        };
    },
};
</script>
